/* import __COLOCATED_TEMPLATE__ from './template-preview.hbs'; */
/* RESPONSIBLE TEAM: team-actions */
import type AppService from 'embercom/services/app-service';
import Component from '@glimmer/component';
import type { BotConfigTarget as Target } from 'embercom/objects/operator/configuration/configuration';
import type Template from 'embercom/models/template';
import { inject as service } from '@ember/service';
import type IntlService from 'ember-intl/services/intl';
import { tracked } from '@glimmer/tracking';
import { action } from '@ember/object';
import { assetUrl } from '@intercom/pulse/helpers/asset-url';
import type TasksAndProceduresList from 'embercom/components/tasks-and-procedures/list';

interface Args {
  selectedTemplateContentObject: { [key: string]: any; target: Target };
  selectedTemplate: Template;
  templates: Template[];
  onClose: () => void;
  transitionBack: () => void;
  recordAnalyticsEvent: (eventName: string) => void;
  createTaskFromTemplate: TasksAndProceduresList['createTaskFromTemplate'];
  selectTemplate: (template: Template) => void;
  disableTransitionBack?: boolean;
  modal: any;
}

enum TabbedPreview {
  WorkflowsBuilder = 'workflows-builder',
  DemoPreview = 'demo-preview',
}

export default class TemplatePreview extends Component<Args> {
  @service declare appService: AppService;
  @service declare intl: IntlService;

  @tracked selectedTabbedPreview: TabbedPreview = TabbedPreview.WorkflowsBuilder;

  get tabbedPreviewOptions() {
    return [
      {
        label: 'outbound.new-content-modal.task.template-preview.demo',
        value: TabbedPreview.DemoPreview,
      },
      {
        label: 'outbound.new-content-modal.task.template-preview.builder',
        value: TabbedPreview.WorkflowsBuilder,
      },
    ];
  }

  @action
  onTabbedPreviewSelected(value: TabbedPreview) {
    this.selectedTabbedPreview = value;
  }

  get demoPreviewUrl() {
    // TODO: Add the video URL for the selected template
    return assetUrl(`/assets/images/workflows/workflows-setup-user-end-preview.gif`);
  }
}

declare module '@glint/environment-ember-loose/registry' {
  export default interface Registry {
    'Outbound::NewContentModal::TaskTemplate::TemplatePreview': typeof TemplatePreview;
    'outbound/new-content-modal/task-template/template-preview': typeof TemplatePreview;
  }
}
